var render = function render(){var _vm=this,_c=_vm._self._c;return _c('TaskList',{attrs:{"title":"Compare Documents","taskType":"compare_doc"}})
}
var staticRenderFns = []

export { render, staticRenderFns }